import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
@Component({
  selector: 'app-delivery-model',
  templateUrl: './delivery-model.component.html',
  styleUrls: ['./delivery-model.component.css'],
})
export class DeliveryModelComponent implements OnInit {
      @Input() benID:any
      @Input() AlraedyDataAdded:any
      
  deliveryForm: FormGroup;
  complicationsList: any[]=[];
  outcomeList: any[]=[];
  typeofDeliveryList: any[]=[];
  deliveryplaceList: any[]=[];
  enableOtheroutcome: boolean = false;
  enableOthercomplication: boolean = false;
  referredist: any[]=[];

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.getDeliveryplace();
    this.gettypeofDelivery();
    this.getOutcome();
    this.getComplications();
    this.getReferred();

      if(this.AlraedyDataAdded){
  setTimeout(() => {
    this.deliveryForm.patchValue(this.AlraedyDataAdded)
    this.isOtherSelected(this.AlraedyDataAdded.outcome_id)
    this.isOtherSelectedcom(this.AlraedyDataAdded.complications_id)
  }, 500);
  }
  }

  formInIt() {
    this.deliveryForm = this.fb.group({
      delivery_place_id: [],
      delivery_type_id: [],
      outcome_id: [],
      if_others_outcome: [],
      complications_id: [],
      if_others_complications: [],
      beneficiary_id: this.benID,
      consult_refer_to_id: []
    });
  }

 isOtherSelected(value:any) {
    if(value == '4'){
      this.enableOtheroutcome =true
      // this.ancForm.get('gravida_para_id')?.setValue(null);
    }else{
       this.enableOtheroutcome =false
      this.deliveryForm.get('if_others_outcome')?.setValue(null);
    }
   
  }
  isOtherSelectedcom(value:any) {
    if(value == '5'){
      this.enableOthercomplication =true
      // this.ancForm.get('highrisk_reason_id')?.setValue(null);
    }else{
       this.enableOthercomplication =false
      this.deliveryForm.get('if_others_complications')?.setValue(null);
    }
   
  }
  getDeliveryplace() {
      this.regService.get(`masters/masters/getalldeliveryplaces`).subscribe({
          next: (res) => {
            if (res.status == 'OK') {
              this.deliveryplaceList = res.data ?? [];
              this.toastr.success(res.message);
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
    }
    gettypeofDelivery() {
        this.regService.get(`masters/masters/getalltypeofdeliverys`).subscribe({
            next: (res) => {
              if (res.status == 'OK') {
                this.typeofDeliveryList = res.data ?? [];
                this.toastr.success(res.message);
              } else {
                let errMsg: string = res.message;
                this.toastr.error(errMsg);
              }
            },
            error: (err: HttpErrorResponse) => {
              this.toastr.error(err.message);
            },
            complete: () => {
              // Any additional logic after patching values
            },
          });
      }
  getOutcome() {
          this.regService.get(`masters/masters/getalloutcomes`).subscribe({
              next: (res) => {
                if (res.status == 'OK') {
                  this.outcomeList = res.data ?? [];
                  this.toastr.success(res.message);
                } else {
                  let errMsg: string = res.message;
                  this.toastr.error(errMsg);
                }
              },
              error: (err: HttpErrorResponse) => {
                this.toastr.error(err.message);
              },
              complete: () => {
                // Any additional logic after patching values
              },
            });
        }
  getComplications() {
            this.regService.get(`masters/masters/getallcomplications`).subscribe({
                next: (res) => {
                  if (res.status == 'OK') {
                    this.complicationsList = res.data ?? [];
                    this.toastr.success(res.message);
                  } else {
                    let errMsg: string = res.message;
                    this.toastr.error(errMsg);
                  }
                },
                error: (err: HttpErrorResponse) => {
                  this.toastr.error(err.message);
                },
                complete: () => {
                  // Any additional logic after patching values
                },
              });
          }

    getReferred() {
    this.regService.get(`masters/masters/getallreferredto`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.referredist = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

    onSave(){
    this.toastr.success("Records Saved After POC Submition")
    setTimeout(() => {
      console.log('Delivery Data',this.deliveryForm.value)
      this.activeModal.close(this.deliveryForm.value)
    }, 200);
   
  }
}
